import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LCFlexContainer from '../../../../components/Layout/LCFlexContainer';
import LCFlexItem from '../../../../components/Layout/LCFlexItem';
import WorkService from '../../../../services/WorkService/WorkService';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import { SolicitationView } from '../../../../models/SolicitationView';
import { WorkView } from '../../../../models/WorkView';
import Modal from '../../../../components/Dialog/Modal';
import LcLoading from '../../../../components/Generic/LcLoading';
import { WorkTimeKeep } from '../../../../models/WorkTimeKeep';

interface PropsWorkList {
    work: WorkView;
    solicitation: SolicitationView;
    onCloseEvent: Function;
    open: boolean;
    content: string;
    confirmMessage: string;
    idConfirm?: string;
    abortMessage: string;
    idAbort?: string;
}

export interface Validate {
    name: string;
    validateMessage: string;
    valid: boolean;
}

const CancelWork: React.FC<PropsWorkList> = (props) => {
    const dispatch = useDispatch();
    const user = useSelector<RootState, UserState>(state => state.user);
    const [workService, setWorkService] = useState<WorkService>(new WorkService(props));
    const [loading, setLoading] = useState<boolean>(false);

    const Save = async () => {
        setLoading(true);

        try {
            var workToSave = {
                ...props.work,
                idUser: user.id as number,
                idStatus: 6
            };

            await workService.updateWork(workToSave);

            if (props.solicitation && props.solicitation.timeKeep) {
                ZerarApontamento();
            }
        }
        catch (e) {
            debugger;
        }

        if (props.onCloseEvent != null) {
            props.onCloseEvent(true);
        }

        setLoading(false);
    }

    var ZerarApontamento = async () => { 
        try {
            var workToSaveCancel: WorkTimeKeep = {
                IdSolicitation: props.work.idSolicitation,
                IdWork: props.work.id,
                IdUser: Number(user.id),
                IdWorkTeam: props.work.idWorkTeam,
                OriginalEstimatedTime: 0,
                TimeRemaning: 0,
                TimeCompleted: 0,
            };

            await workService.SetTimeKeep(workToSaveCancel);

            dispatch({ type: "PREF_TIMEKEEP_WORK", payload: true });
        }
        catch (e) {
            console.error(e);
            debugger;
        }
    }

    const setClose = () => {
        if (props.onCloseEvent != null) props.onCloseEvent(false);
    }

    return (
        <Modal title={'Cancelar trabalho'} visible={props.open} close={() => setClose()}>
            <LcLoading loading={loading} label="Carregando...">
                <LCFlexContainer spacing={2}>
                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        Tem certeza que deseja cancelar o trabalho?
                    </LCFlexItem>

                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <div className="row">
                            <button
                                style={{ margin: '10px' }}
                                className='lc-button bg-info'
                                id={'Ok'}
                                onClick={() => Save()}
                                color="primary"
                            >
                                Ok
                            </button>
                            <button
                                style={{ margin: '10px' }}
                                className='lc-button bg-info'
                                id={'Cancelar'}
                                onClick={() => setClose()}
                                color="primary"
                            >
                                Cancelar
                            </button>
                        </div>
                    </LCFlexItem>
                </LCFlexContainer>
            </LcLoading>
        </Modal>
    );
};

export default CancelWork;